import { faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeObservable, observable } from 'mobx';

import { Filtro } from './Filtro';

export default class FiltroProcessosAssociados extends Filtro {
    tipo = 'booleano';

    exibicao = 'checkbox';

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            tipo: false,
            exibicao: false,
            label: false,
            getIconeFiltroRapido: false,
            getValorOpcao: false,
            getDescricao: false,
            filtroRapido: observable
        });
    }

    get label() {
        return 'Com processos associados';
    }

    getIconeFiltroRapido() {
        return (
            <FontAwesomeIcon
                icon={faLink}
                style={{ fontSize: '22px' }}
            />
        );
    }

    getValorOpcao(registro) {
        return Array.isArray(registro?.processo?.associados) && registro.processo.associados.length > 0;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
